import * as styles from './index.css';
import Stack from '@blueshift-ui/core/dist/components/stack';

function ActionGroup({ children }: React.PropsWithChildren<object>) {
  return (
    <Stack className={styles.actions} direction={{ xs: 'column', sm: 'row' }}>
      {children}
    </Stack>
  );
}

export default ActionGroup;
